import {useContext, useState} from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import AddIcon from '@mui/icons-material/Add'
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord'
import {SpaceContext} from '../SpaceProvider.tsx'
import AddWidgetDrawer from './AddWidgetDrawer.tsx'

const EditDrawer = ({cancelEditMode}: { isEditing: boolean, cancelEditMode: () => void }) => {
  const [, spaceConfig, , saveWidgetConfig] = useContext(SpaceContext)!
  const [addOpen, setAddOpen] = useState(false)

  return (
    <>
      <Box sx={{
        width: 320, flexShrink: 0, borderLeft: '1px solid', borderColor: 'divider',
        bgcolor: 'background.paper', display: 'flex', flexDirection: 'column',
        position: 'sticky', top: 64, alignSelf: 'flex-start', height: 'calc(100vh - 64px)',
      }}>
        {/* Header */}
        <Box sx={{p: 2.5, pb: 1.5}}>
          <Typography variant="h6" fontWeight={700}>Edit Mode</Typography>
          <Typography variant="body2" color="text.secondary">Customize your dashboard layout</Typography>
        </Box>

        {/* How to Edit */}
        <Box sx={{mx: 2.5, mb: 2, p: 2, borderLeft: '3px solid #1976d2', bgcolor: '#f0f7ff', borderRadius: 1}}>
          <Typography variant="subtitle2" color="primary" gutterBottom>How to Edit</Typography>
          {['Drag the grip handle to move widgets', 'Use resize buttons to change size', 'Click X to remove widgets'].map(t => (
            <Typography key={t} variant="body2" color="text.secondary" sx={{pl: 1, '&::before': {content: '"•  "'}}}>{t}</Typography>
          ))}
        </Box>

        {/* Add Widget */}
        <Box sx={{px: 2.5, mb: 2}}>
          <Button variant="contained" fullWidth startIcon={<AddIcon/>}
                  onClick={() => setAddOpen(true)}
                  sx={{borderRadius: 2, py: 1.2, textTransform: 'none', fontWeight: 600}}>
            Add Widget
          </Button>
        </Box>

        {/* Active Widgets */}
        <Box sx={{px: 2.5, flex: 1, overflow: 'auto'}}>
          <Typography variant="subtitle2" sx={{mb: 1.5}}>Active Widgets</Typography>
          {spaceConfig.filter((w: any) => !w.is_removed).map((item: any) => (
            <Box key={item.id} sx={{display: 'flex', alignItems: 'center', gap: 1.5, p: 1.5, mb: 1, border: '1px solid', borderColor: 'divider', borderRadius: 1.5}}>
              <FiberManualRecordIcon sx={{fontSize: 12, color: '#4caf50'}}/>
              <Typography variant="body2">{item.metadata?.name || item.slug}</Typography>
            </Box>
          ))}
        </Box>

        {/* Footer */}
        <Box sx={{p: 2.5, display: 'flex', gap: 1.5, borderTop: '1px solid', borderColor: 'divider'}}>
          <Button variant="outlined" fullWidth onClick={cancelEditMode}
                  sx={{borderRadius: 2, textTransform: 'none'}}>Cancel</Button>
          <Button variant="contained" fullWidth onClick={saveWidgetConfig}
                  sx={{borderRadius: 2, textTransform: 'none', fontWeight: 600}}>Save Changes</Button>
        </Box>
      </Box>

      <AddWidgetDrawer open={addOpen} onClose={() => setAddOpen(false)}/>
    </>
  )
}

export default EditDrawer
